import { Injectable } from '@angular/core'
import { from, Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import { AppConfigService } from '../services/app-config.service'
import { ParametersService } from '../services/parameters.service'
import { ServerUrlService } from '../services/server-url.service'

import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router'

@Injectable({
  providedIn: 'root',
})
export class ServerUrlGuard implements CanActivate, CanActivateChild {
  constructor(
    private serverUrl: ServerUrlService,
    private parameterService: ParametersService,
    private appConfig: AppConfigService
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const client = next.paramMap.get('client') || this.serverUrl.getName()
    return this.loadFromCMS(client)
  }

  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const client = next.paramMap.get('client') || this.serverUrl.getName()
    return this.loadFromCMS(client)
  }

  private loadFromCMS(client: string): Observable<boolean> {
    const cmsServer = this.appConfig.cmsServerUrl
    return from(
      fetch(`${cmsServer}/variables/host/${client}`, {
        method: 'POST',
      }).then((val) => val.json())
    ).pipe(
      map((val: any) => {
        this.serverUrl.url = val.find((el: any) => el.chave === 'Auto_Atendimento_URL').valor
        this.serverUrl.timezone = val.find((el: any) => el.chave === 'Timezone').valor
        this.serverUrl.otimusClinicUrl = val.find((el: any) => el.chave === 'Otimus_URL').valor
        this.parameterService.appearanceEnabled = val.find(
          (el: any) => el.chave === 'Auto_Atendimento_Aparencia'
        ).valor
        return true
      })
    )
  }
}
